import React, { useState } from 'react';
import '../css/Login.css';
import { Link } from 'react-router-dom';
import { firestore } from '../firebase';
import { createUserWithEmailAndPassword, getAuth, validatePassword } from 'firebase/auth';
import { doc, setDoc, collection, query, where, getDocs } from 'firebase/firestore';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(''); // State to store error message
    const [success, setSuccess] = useState(''); // State to display success message

    // Function to generate a random number string
    const generateRandomNumbers = (length = 4) => {
        return Math.floor(Math.random() * Math.pow(10, length)).toString().padStart(length, '0');
    };

    // Function to generate a valid username
    const generateUsername = async (email) => {
        try {
            // Get the part before @ and remove any non-alphanumeric characters
            let baseUsername = email.split('@')[0].replace(/[^a-zA-Z0-9_]/g, '');
            
            // If the base username is too short, use 'user' instead
            if (baseUsername.length < 3) {
                baseUsername = 'user';
            }
            
            // If the base username is too long, truncate it
            if (baseUsername.length > 30) {
                baseUsername = baseUsername.substring(0, 30);
            }

            // Check if username exists
            const usersQuery = query(
                collection(firestore, "users"),
                where("username", "==", baseUsername)
            );
            const usersSnapshot = await getDocs(usersQuery);
            
            // If username exists, add random numbers
            if (!usersSnapshot.empty) {
                return `${baseUsername}${generateRandomNumbers()}`;
            }
            
            return baseUsername;
        } catch (error) {
            // If anything fails, return 'user' with random numbers
            return `user${generateRandomNumbers()}`;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear any previous error messages
        setSuccess(''); // Clear any previous success messages

        if (!email || !password) {
            setError('Email and password are required.');
            return;
        }
        const auth = getAuth();
        const status = await validatePassword(auth, password);
            if (!status.isValid) {
            let errorMessage = 'Password is weak. You do not meet the following requirements:';
            if (status.containsLowercaseLetter === undefined) {
                errorMessage += '\n a Lowercase character';
        }
            if (status.containsUppercaseLetter === undefined) {
                errorMessage += '\n an Uppercase character';
        }
            if (status.containsNumber === undefined) {
                errorMessage += '\n a Numeric character';
        }
            if (status.containsNonAlphanumericCharacter === undefined) {
                errorMessage += '\n a Special character (e.g., !@#$%^&*)';
        }
            if (password.length < 6) {
                errorMessage += '\n a Minimum length of 6 characters';
        }
        setError(errorMessage);
        return;
  }
        

        try {
            // Create user with Firebase Auth
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const { uid } = userCredential.user;

            // Generate username
            const username = await generateUsername(email);

            // Store user in Firestore
            await setDoc(doc(firestore, 'users', uid), {
                email: email,
                username: username,
                createdAt: new Date(), //Save account creation timestamp
            });

            setSuccess('Account created successfully! You can now log in.');
        } catch (err) {
            setError('Failed to create an account. Please try again.');
        }
    };

    return (
        <div className="register-container">
            <form className="register-form" onSubmit={handleSubmit}>
                <h2>Register</h2>
                {error && <p className="error-message">{error}</p>} {/* Display error message */}
                {success && <p className="success-message">{success}</p>} {/* Display success message */}
                <label htmlFor="email">
                    Email:
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </label>
                <label htmlFor="password">
                    Password:
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </label>
                <button type="submit">Register</button>
                <p>
                    Already Registered? <Link to="/login">Login</Link>
                </p>
            </form>
        </div>
    );
};

export default Register;
